import { render, staticRenderFns } from "./BankChangeActivationType.vue?vue&type=template&id=1e554ca8&"
import script from "./BankChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./BankChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports